import { initialOptionValues } from '../constants';
const OPTIONS_COUNTS = 3;
export const getDefaultOptionsObj = () => {
  let optionsObj = {};
  for (let i = 1; i <= OPTIONS_COUNTS; i++) {
    optionsObj[i] = initialOptionValues;
  }
  return optionsObj;
};
